import { Box } from '@mui/material';
import { getSampleById } from 'actions/LaboratoryActions';
// import GeneralPwdHeader from 'PdfPages/components/PwdHeader';

// import GeneralPwdFooter from 'PdfPages/components/PwdFooter';

import A4 from 'PdfPages/pages/A4';
import { useEffect } from 'react';
import useQuery from 'utils/getQueryParams';
import { connect } from 'react-redux';
import { IReducer } from 'Reducers/IReducer';
import { bindActionCreators } from 'redux';
import { ILaboratoryDetails } from 'Reducers/LaboratoryReducer/ILaboratoryReducer';
import { IDepartment, ISample } from 'exactt-types/lib';
import GeneralFields, { GeneralFieldsValue } from 'PdfPages/components/GeneralFields';
import DocumentLatterHead from 'PdfPages/components/DocumentLatterHead';
import moment from 'moment';
import QRCode from 'react-qr-code';

interface SampleJobAllocationPrintProps {
  setDisableScroll: (value: boolean) => void;
  getSampleById: (laboratoryId: string, _id: string) => Promise<any>;
  laboratory: ILaboratoryDetails | null;
  sampleDetails: ISample | null;
}

export function _SampleJobAllocationPrint(props: SampleJobAllocationPrintProps) {
  let query = useQuery();
  let sampleId = query.get('id');

  console.log('SampleJobAllocationPrint', props.laboratory);

  const onFocus = async () => {
    if (sampleId) {
      await props.getSampleById(props.laboratory?.details._id || '', sampleId);
      setTimeout(() => {
        // window.print();
      }, 1000 * 5);
      // setLoading(false);
    }
  };

  useEffect(() => {
    props.setDisableScroll(true);
    onFocus();

    // eslint-disable-next-line
  }, []);

  const values: GeneralFieldsValue[] = [];
  const footerValues: GeneralFieldsValue[] = [];

  if (props.sampleDetails) {
    values.push({ label: 'Commodity', value: props.sampleDetails.name });
    values.push({ label: 'Lab Code', value: (props.sampleDetails.sampleId || '').replace('HTL/', '') });
    values.push({
      label: 'Date of receipt',
      value: moment(props.sampleDetails.collectionDate).format('DD-MM-YYYY') || '',
    });
    footerValues.push({
      label: 'Date of Allocation',
      value: moment(props.sampleDetails.collectionDate).format('DD-MM-YYYY') || '',
    });
    footerValues.push({
      label: 'Allotted by',
      value: '',
    });
  }

  return (
    <Box>
      <A4
        header={<DocumentLatterHead laboratory={props.laboratory} />}
        body={
          <>
            <Box border={'1px solid #000'} p={2} style={{ marginTop: -5 }}>
              <Box textAlign={'center'} mb={1} fontWeight={'bold'}>
                JOB SHEET ALLOCATION RECORD
              </Box>
              <GeneralFields values={values} labelWidth={134} />
              <Box display={'flex'} justifyContent={'flex-end'}>
                <div>
                  <div style={{ height: 'auto', margin: '0 auto', maxWidth: 32, width: '100%' }}>
                    <QRCode
                      size={256}
                      style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                      value={props.sampleDetails?.sampleId as string}
                      viewBox={`0 0 256 256`}
                    />
                  </div>
                </div>
              </Box>
            </Box>
            <Box className="table-with-border">
              <table style={{ width: '100%', marginTop: -1 }}>
                <thead>
                  <tr>
                    <th style={{ width: '6%' }}>Sr. No</th>
                    <th style={{ width: '20%' }}>Section</th>
                    <th style={{ width: '30%' }}>Allotted Test Parameter</th>
                    <th style={{ width: '40%' }}>Allotted to Chemist / Microbiologist / Analyst</th>
                  </tr>
                </thead>
                <tbody>
                  {props.sampleDetails?.parameters?.map((i, index) => (
                    <tr>
                      <td style={{ textAlign: 'center' }}>{index + 1}</td>
                      <td style={{ textAlign: 'center' }}>{(i.department as IDepartment)?.name}</td>
                      <td style={{ textAlign: 'center' }}>{i?.name}</td>
                      <td style={{ textAlign: 'center' }}>{(i.assignTo as any)?.name}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          </>
        }
        footer={
          <>
            <div style={{ marginTop: 10 }}>
              <GeneralFields values={footerValues} labelWidth={120} />
            </div>
          </>
        }
      // finalFooter={<GeneralFinalFooter />}
      />
    </Box>
  );
}

const mapStateToProps = (state: IReducer) => ({
  laboratory: state.laboratory.current,
  sampleDetails: state.laboratory.sampleDetails,
});

function mapDispatchToProps(dispatch: any) {
  return {
    ...bindActionCreators(
      {
        getSampleById,
      },
      dispatch
    ),
  };
}

export const SampleJobAllocationPrint = connect(mapStateToProps, mapDispatchToProps)(_SampleJobAllocationPrint);
